




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'DealersCPFFormListIframe';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: 'OEM_DealersCPFForm',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
})).extend({
	computed: {
		src() {
			return `/DMS3/CPF/CorporateProfile/List/${this.DealerId}/${this.isOEM}`;
		},
	},
	data() {
		return {
			dealerId: this.$route.query.dealerTenantCode,
			isOEM: true as boolean,
		};
	},
});
